export const getWaivePointsDetails = (pendingCreationLegs = [], pendingCancellationLegs = [], reason = '') => {
  const newProducts = pendingCreationLegs?.map((leg) => leg?.bookingItems?.map((product) => product))?.flat() ?? [];
  const oldProducts = pendingCancellationLegs?.map((leg) => leg?.bookingItems?.map((product) => product))?.flat() ?? [];

  const newProductPriceDetails = newProducts.map((product, index) => {
    const fondedOldProduct = oldProducts.find(
      (oldProduct, oldProductIndex) => oldProduct.passengerId === product.passengerId && index === oldProductIndex
    );

    return {
      itemRefId: Number(product.itemRef),
      value: String(fondedOldProduct?.loyaltyPoints ?? product.loyaltyPoints),
      key: 'original_points_price'
    };
  });

  const newProductCancelReasons = newProducts.map((product) => ({
    key: 'exchange_reason',
    value: reason || 'Miscellaneous',
    itemRefId: Number(product.itemRef)
  }));

  return newProductPriceDetails.concat(newProductCancelReasons);
};

export default getWaivePointsDetails;
